/**
 * 员工餐费自助接口（用户态, accessToken 鉴权）。
 * 与科长(NB100002)聊天窗口里的「用餐统计」日历使用。
 * @author niebu
 */
import http from './httpRequest.js'

export default {
	// 我的月度用餐统计: {days, lunchCnt, dinnerCnt, monthFee, mealTotal, payTotal, balance, empId, emps}
	// empId 可空: 一个账号挂多份档案(如 牛牛/牛牛仔)时指定看谁,不传默认第一份
	myMonth(month, empId) {
		const params = { month };
		if (empId) params.empId = empId;
		return http({ url: '/meal/my/month', method: 'GET', params });
	},
	// 自助充值申请: {amount, proofUrl, empId?} 管理员审核通过后自动入账
	recharge(data) {
		return http({ url: '/meal/my/recharge', method: 'POST', data });
	},
	// 我的充值申请记录(近20条,含审核状态)
	myRecharges(empId) {
		const params = {};
		if (empId) params.empId = empId;
		return http({ url: '/meal/my/recharges', method: 'GET', params });
	},
	// 创建手机扫码上传会话: {sid, expireSeconds}
	mupCreate() {
		return http({ url: '/meal/my/mup/create', method: 'POST' });
	},
	// 轮询扫码上传会话状态(取回手机端已传图片): {alive, urls}
	mupStatus(sid) {
		return http({ url: '/meal/my/mup/status', method: 'GET', params: { sid } });
	},
	// 标记/取消不吃: {date:'yyyy-MM-dd', mealType:1中/2晚, cancel:false标记/true取消}
	skip(data) {
		return http({ url: '/meal/my/skip', method: 'POST', data });
	}
}
